import React, { useEffect, useState } from 'react';
import { RealityWarper } from './RealityWarper';
import { RealityWarperContext } from './RealityWarperContext';
import { FlagState } from './types';

export interface RealityWarperStore {
    featureFlags: FlagState;
    updateFlagState: (state: Partial<FlagState>) => void;
}

export const RealityWarperContextProvider: React.FC<{
    children: React.ReactNode;
    featureFlags: FlagState;
}> = ({ children, featureFlags }) => {
    const [flagState, setFlagState] = useState(featureFlags);

    useEffect(() => {
        setFlagState((prev) => ({
            ...prev,
            ...featureFlags,
        }));
    }, [featureFlags]);

    const updateFlagState = (partialState: Partial<FlagState>) => {
        setFlagState((prevState) => {
            const cleanedState: Partial<FlagState> = {};

            for (const [key, value] of Object.entries(partialState)) {
                if (value !== undefined) {
                    cleanedState[key as keyof FlagState] = value;
                }
            }

            return {
                ...prevState,
                ...cleanedState,
            } as FlagState;
        });
    };

    return (
        <RealityWarperContext.Provider
            value={{ featureFlags: flagState, updateFlagState }}
        >
            <RealityWarper
                flagState={flagState}
                updateFlagState={updateFlagState}
            />
            {children}
        </RealityWarperContext.Provider>
    );
};
